var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"member"},[_c('h2',[_vm._v(_vm._s(_vm.member.firstname))]),_c('h3',[_vm._v(_vm._s(_vm.member.lastname))]),_c('p',[_vm._v(_vm._s(_vm.member.role))])])}
var staticRenderFns = []

export { render, staticRenderFns }